if (window.location.pathname.includes("admin/alerts")) {
    $.each($(".data-table"), function() {
        $(this).data("options", {});
    });

    $(window).on('popup_open', function (e, type, data) {
        if (type !== 'editor-admin-alert-template') return;
        if (!data) {
            $('select[name="alert_template[date_trigger]"]').trigger("change");
            return;
        }

        let alert = data.response.alert_template;

        $('.alert_operation').text(alert.timing_add ? "add" : "subtract");
        $('select[name="alert_template[roles]"]').val(alert.roles).trigger("change");
        $('select[name="alert_template[users]"]').val(alert.users).trigger("change");
        $('select[name="alert_template[property_statuses]"]').val(alert.property_statuses).trigger("change");
        $('select[name="alert_template[date_trigger]"]').val(alert.date_trigger).trigger("change");

        if (alert.coordinators) {
            const coordinators = [];
            alert.coordinators.forEach(coordinator => {
                coordinators.push(coordinator);
                const select = $('select[name="alert_template[coordinators]');
                const element = Array.from(document.querySelector('select[name="alert_template[coordinators]').options).find(opt => opt.value === coordinator);
                const $element = $(element);
    
                $element.detach();
                select.append($element);
                select.val(coordinators).trigger("change");
                select.trigger("change");
            });
        }
    });


    $("[name='alert_template[date_trigger]']").on("change", function (e) { 
        const val = $(this).val();
        const trigger = window.triggers.find((trigger) => trigger.id === val);

        if (trigger) {
            const tokensItems = window.tokens.find((token) => token.model === trigger.model);
            $('input[name="alert_template[model]"]').val(trigger.model).trigger("change");
            $('.alert_timing_description').html(trigger.description);

            if (tokensItems && tokensItems.tokens) {
                const tokens = tokensItems.tokens ? tokensItems.tokens.sort().join("}</mark></li><li><mark>{") : "---";
                $('.alert_tokens').html("<li><mark>{" + tokens + "}</mark></li>");
            }
        }
    });

    function sortSelection (el, evt) {
        const element = evt.params.data.element;
        const $element = $(element);

        $element.detach();
        $(el).append($element);
        $(el).trigger("change");
    }

    $('select[name="alert_template[coordinators]').on("select2:select", function (evt) {
        sortSelection(this, evt);
    });

    $('select[name="alert_template[users]').on("select2:select", function (evt) {
        sortSelection(this, evt);
    });

    $('input[name="alert_template[timing_add]"]').on("change", function () {
        $('.alert_operation').text($(this).prop('checked') ? 'add' : 'subtract');
    });

    $('input[name="alert_template[sales_rep]"]').on("change", function () {
        $('.assignees select').prop('disabled', $(this).prop('checked'));
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/alerts.js